import { connect } from 'react-redux';

import { client } from '@biw/contests-core';
import { getUserInitials, getAvatarUrl, getAccountBalance } from 'dux/user/selectors';
import { logout } from 'dux/user/actions';

export const mapStateToProps = (state: any) => ( {
    userInitials: getUserInitials( state ),
    avatarUrl: getAvatarUrl( state ),
    mediaLabel: client.selectors.getMediaLabel( state ),
    accountBalance: getAccountBalance( state ),
} );

export const mapDispatchToProps = {
    logout,
};

export default connect( mapStateToProps, mapDispatchToProps );
